import { ResetMatrixCommand } from "slotworks/commands/betbar/reset-matrix-command";
import { ResetToTriggeringSpinCommand } from "slotworks/commands/betbar/reset-to-triggering-spin-command";
import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import Layers from "slotworks/graphics/layers/layers";
import GameState from "slotworks/model/game-state";
import Gamestate from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel"; import Sequence from "slotworks/utils/contracts/sequence";
import Gameplay from "slotworks/model/gameplay/gameplay";

export default class ExitFreespins extends State {

    public static INCLUDE_BASE_WIN: boolean = true;
    protected summaryScenes: string[] = ["freespinssummary", "freespins"];

    protected prompt: PromptContent;

    public onEnter() {

        SmartUIFlags.set(SmartUIFlag.IDLE, false);

        this.prompt = null;
        new Sequence([
            () => this.beforePrompt(),
            () => this.setupPrompt(),
            () => this.showPrompt(),
            () => this.afterPrompt()
        ]).then(() => this.complete());
    }

    public complete() {
        this.setWinnings();
        super.complete();
    }

    protected beforePrompt() {
        return Contract.empty();
    }

    protected setupPrompt() {
        return Contract.wrap(() => {
            SmartUIFlags.set(SmartUIFlag.PROMPT, true);

            const gameplay: Gameplay = Gamestate.getCurrentGame();

            let freeSpinsWin: number = 0;
            if (ExitFreespins.INCLUDE_BASE_WIN) {
                freeSpinsWin = gameplay.getTotalWin();
            } else {
                freeSpinsWin = gameplay.getTotalChildrenWin(gameplay.getRootRecord());
            }

            let message;
            let summaryScene;

            if (freeSpinsWin > 0) {
                message = Services.translations.get("fs.wsu", { VALUE: freeSpinsWin });
                summaryScene = "freespinssummary";
            } else {
                message = Services.translations.get("fs.nws");
                summaryScene = "freespinsnowin";
            }

            const freespinsPlayed = gameplay.getTotalFreespinsWon().toString();

            if (!this.prompt) {
                this.prompt = new PromptContent([summaryScene, ...this.summaryScenes], 4000);
            }

            this.prompt.addContinueButton("continue");

            this.prompt.setText("winMessage", message);
            this.prompt.setText("played", freespinsPlayed);

            this.prompt.countupText("value", freeSpinsWin, 2000);
        });
    }

    protected showPrompt(): Contract<void> {
        return Components.prompt.showPrompt(this.prompt);
    }

    protected afterPrompt(): Contract<void> {
        return new Parallel([
            () => Contract.wrap(() => SmartUIFlags.set(SmartUIFlag.PROMPT, false)),
            () => this.hideFreespinsComponents(),
            () => this.resetToTriggeringSpin(),
            () => this.resetMatrix()
        ]);
    }

    protected hideFreespinsComponents(): Contract<void> {
        return new Parallel([
            this.resetLayer(Layers.Background),
            this.resetLayer(Layers.MatrixBackground),
            this.resetLayer(Layers.Header),
            () => Contract.wrap(() => Components.banner.setMode("default")),
            () => Contract.wrap(() => Components.footer.showDefaultText())
        ]);
    }

    protected resetLayer(layer: Layers) {
        if (layer.getCurrentScene().name === "default") {
            return () => Contract.empty();
        } else {
            return () => layer.defaultScene();
        }
    }

    protected resetToTriggeringSpin() {
        return Contract.wrap(() => ResetToTriggeringSpinCommand());
    }

    protected resetMatrix() {
        return Contract.wrap(() => ResetMatrixCommand());
    }

    protected setWinnings(): void {
        const totalWin = GameState.getCurrentGame().getTotalWin();
        Services.transaction.setWinnings(totalWin, totalWin, 750).execute();
    }
}
